import React from "react";

const AbouteCertificateCard = () => {
  return (
    <div style={{ padding: "20px", marginTop: "5%", marginBottom: "10%" }}>
      <div
        style={{
          marginTop: "5%",
          gap: "5%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: "row",
          flexWrap: "wrap",
        }}
      >
        <div style={{ flex: 1, minWidth: "300px", paddingRight: "20px" }}>
          <img
            style={{
              width: "100%",
              height: "auto",
              marginBottom: "10%",
              borderRadius: "10px",
            }}
            src={"https://i.postimg.cc/gkQxbfgM/certificate-SMIT.png"}
            alt="certificate"
            className="img-fluid"
          />
        </div>

        <div
          style={{
            flex: 1,
            display: "flex", 
            flexDirection: "column", 
            justifyContent: "center", 
            alignItems: "center", 
            textAlign: "center",
          }}
        >
          <h1
            style={{
              fontSize: "2.1em",
              paddingBottom: "20px",
              marginBottom: "3%",
              textAlign: "center", 
            }}
          >
            <strong className="purple">Certificate</strong> from SMIT Institute
          </h1>
          <h3 style={{ lineHeight: "1.5" }}>
            I have,
            <strong className="purple"> 𝖘𝖚𝖈𝖈𝖊𝖘𝖘𝖋𝖚𝖑𝖑𝖞</strong> completed my
            Web/App Development course. I am deeply grateful to Allah for His
            blessings and immensely thankful to my teacher,
            <strong className="purple"> "Muhammad Sir Abdullah"</strong>
          </h3>
        </div>
      </div>
    </div>
  );
};

export default AbouteCertificateCard;
